import { Component, Inject, Input, OnInit, computed, signal } from '@angular/core';
import { CommonModule, NgOptimizedImage, ViewportScroller } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { DemoMaterialModule } from '../demo-material-module';
import { UserCompanyService } from '../services/userCompany.service';
import { environment } from 'src/environments/environment';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { PlatformApiWpService } from '../services/platform-apiwp.service';
import { CartElement, CartService } from '../services/cart.service';
import { PromoFeaturesComponent } from './components/promo-features/promo-features.component';
import { ReportService } from '../services/report.service';
import { EventData, EventInteractionService } from '@mare-common/ngx-mare-common';
import { ReportPlanInterface } from './report-plan';
import { ComponentIdentityReportComponent } from '../dashboard/dashboard-components/component-identity-report/component-identity-report.component';
import { DownloadAnimationDirective } from '../shared/directives/download-animation.directive';
// export interface ReportPlan{
//   name: string;
//   features?: Array<any>;
//   reports: number;
//   sku: string;
//   price: number;
//   specialprice: number;
//   description: string;
//   order: number;
// }

@Component({
  selector: 'page-report,promo-report',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    DemoMaterialModule,
    NgOptimizedImage,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    PromoFeaturesComponent,
    ComponentIdentityReportComponent
  ],
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss'],
})
export class ReportComponent implements OnInit {
  public hero: any;
  formReport: any = new FormGroup({});
  user: any;
  company: any;
  companyEureso: any;
  companyPiva: any;
  myPiva$ = computed(() => {
    return this.company?.alternateSummary?.vatRegistrationNumber
  })
  reportPlans: any;
  reportDigitale: any;

  @Input() featureMode: 'carousel' | 'list' = 'list';


  // reportBundles$ = computed(() => {
  //   return this.reportPlans
  // })

  constructor(private _formBuilder: FormBuilder,
    private userCompanyService: UserCompanyService,
    private platformApiWpService: PlatformApiWpService,
    private cartService: CartService,
    private reportService: ReportService,
    private eventInteractionService: EventInteractionService,
    private viewportScroller: ViewportScroller,
    private activeRoute: ActivatedRoute
  ) {

    this.eventInteractionService.getObservable().subscribe((event: EventData) => {

      switch (event.event) {
        case 'addToCart':
          if (event.data?.sku) {
            let basicPlan = this.reportPlans.find((plan: ReportPlanInterface) => plan.sku === event.data.sku);
            if (basicPlan) {
              this.buyPlan(basicPlan);
            }
          }
          
          break;
        case 'scrollToPlans':
          this.scrollToElement('plans');
          break;
        default:
          break;
      }
    });
console.log(this.activeRoute.snapshot)
    let isPage = this.activeRoute.snapshot?.queryParams['isPage'] ? this.activeRoute.snapshot.queryParams['isPage'] : false

    if (isPage) {
      this.hero = {
        title: 'page.report.hero_title',
        content: 'page.report.hero_content',
        image: environment.assetsPrefixUrl + '/images/report-ai.svg'
      }
    }
  
  }

  ngOnInit(): void {
    // this.buildForm();
    this.updateFormWithUserData();
    this.reportService.getReportBundle().then((res: any) => {
      this.reportDigitale = res.reportDigitale;
      this.reportPlans = res.reportPlans;
    });
    // this.getReportBundle();
  }

  buildForm() {
    this.formReport = this._formBuilder.group({
      vatNumber: ['', Validators.required],
      website: [''],
      productPrice: ['', Validators.required]
    })
  }

  updateFormWithUserData() {
    this.userCompanyService.userCompany$.subscribe((res: any) => {
      if (res) {
        this.company = res.company;
        this.companyPiva = this.company?.piva
        this.companyEureso = this.company?.eureso_overview;
        // if (this.company?.alternateSummary?.vatRegistrationNumber)
        //   this.formReport.patchValue({ vatNumber: this.company.alternateSummary.vatRegistrationNumber });
        // if (this.company?.contactInformation?.websites[0])
        //   this.formReport.patchValue({ website: this.company.contactInformation.websites[0] });
      }
      // console.log('company', this.company)
      // this.formReport.updateValueAndValidity();
    })

  }

  submitAndGetReport() {
    this.formReport.markAllAsTouched();
  }

  // getReportBundle() {
  //   let body = {
  //     skus: 'report-digitale',
  //     getVariations: true
  //   }
  //   this.platformApiWpService.postRequest('/msc/v1/searchProducts', body).then((sub: any) => {
  //     sub.subscribe((res: any) => {
    
  //       this.reportDigitale = res.payload.products.find((el: any) => el.sku == 'report-digitale');
  //       // add a condition if object reportDigitale?.product_options has a key 'pa_bundle-report'
  //       // create an array with the name and the number of reports
  //       if (this.reportDigitale?.variations && this.reportDigitale?.variations.length > 0) {
  //         console.log(this.reportDigitale);
  //         this.reportPlans = this.reportDigitale?.variations.map((el: any) => {
  //           let extracOptions: Array<any> = [];
  //           if (el.attributes) {
  //             Object.keys(el.attributes).forEach((key: any) => {
  //                 extracOptions.push(el.attributes[key].name)
  //             })
  //           }
  //           return {
  //             name: el.attributes['pa_bundle-report'].name,
  //             features: extracOptions,
  //             reports:el.attributes['pa_bundle-report'].meta['number-report'][0] ?? 0,
  //             sku: el.sku,
  //             price: el.regular_price,
  //             specialprice: el.price !== el.regular_price ? el.price : null,
  //             description: el.variation_description,
  //             order:el.attributes['pa_bundle-report'].meta['order'][0] ?? 0,
  //           }
  //         });
  //         this.reportPlans.sort((a: any, b: any) => a.price - b.price)
          
  //       }

  //     })
  //   })
  // }

  scrollToElement(elementId: string): void { 
		this.viewportScroller.scrollToAnchor(elementId);
	}

  buyPlan(plan: ReportPlanInterface) {
    
    
    const data: CartElement =
    {
      name: plan.name,
      price: plan.price,
      sku: 'report-digitale',
      // variationSku: 'report-digitale-' + plan.slug,
      variationSku: plan.sku,
      bundleName: this.reportDigitale.name,
      bundleImage: this.reportDigitale.image_url ?? null,
      bundleDescription: this.reportDigitale.description ?? null,
      params: {
        piva: this.companyPiva,
        thwepof_options: {
          piva: {
            name: 'piva',
            value: this.companyPiva,
            type: "inputtext",
            label: 'Partita IVA',
            options: ''
          }
        }
      }
    }
    this.cartService.addToCart(data, true).then((res: any) => {

      this.cartService.checkout().then((res: any) => {
        console.log(res)
      })
    });
  }

  quotePlan(plan?: ReportPlanInterface) {
    this.eventInteractionService.publishData({ event: 'openAssistanceForm' });
  }


}

@Component({
  selector: 'app-report-modal',
  standalone: true,
  templateUrl: './report-modal.component.html',
  styleUrls: ['./report.component.scss'],
  imports: [
    MatDialogModule,
    CommonModule,
    MatButtonModule,
    NgOptimizedImage,
    TranslateModule,
    DownloadAnimationDirective,
  ],
})

export class ReportModalComponent {

  constructor(
    public dialogRef: MatDialogRef<ReportModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ReportModalData,
    private reportService: ReportService
  ) { }
  onNoClick(): void {
    this.dialogRef.close();
  }
  downloading$ = signal(false);

  getFreeReport() {
    let piva = this.data.piva;
    console.log(this.data);
    this.downloading$.update(val => true);
    this.reportService.downloadReport(piva,true).then((res: any) => {
      // this.downloading$.update(val => false);
      // this.dialogRef.close();
    })
  }
}

export interface ReportModalData {
  productName: string;
  productPrice: number;
  freeOffer:boolean;
  title?: string;
  content?: string;
  piva?: string;
  user?: any;
  buttons?: Array<{
    text: string;
    action: () => void
  }>;
}
